export default __webpack_public_path__ + "static/media/wishlist.501e8837.svg";